<template>
    <v-container class="quoteSummary" >
      <center v-if="totalPending"><img class="imgLoader" src="../../shared/assets/images/3dloader.gif"  /></center>
      <v-form v-else>
      <v-layout row wrap style="padding-right: 200px !important;">
          <v-flex xs6>
            <label class="blackLabel pr-2">CURRENT FILTERS:</label>
            <v-btn small class="elevation-5" @click="fncOpenFilters" style="display: inline; margin-top: 1px; height: 33px;font-size: 9px !important; width: 5px;" color="info"><i class="material-icons">filter_alt</i>Filters</v-btn>
          </v-flex>
          <v-flex xs2></v-flex>
          <v-flex xs4>
            <v-btn  small @click.prevent="fncGenerateStatusSummaryReport()" class="elevation-5" style="display: block; float:right; margin-top: 1px; height: 39px;" color="info"><i class="material-icons">summarize</i>Download Summary</v-btn>
            <!--            <v-switch style="float: right"v-model="showZero" label="Show 0 Values"  ></v-switch>-->
          </v-flex>

        <template v-if="isReportSearch" >
          <v-flex xs2>
            <label style="font-weight: 500;" class="blackLabel " >Date:</label>
          </v-flex>
          <v-flex xs10 >
            <span>{{quote_start_date}} to {{quote_end_date}}</span>
          </v-flex>
          <v-flex xs2>
            <label style="font-weight: 500;" class="blackLabel " >Report Search:</label>
          </v-flex>
          <v-flex xs10 >
            <span>{{reportSearch}}</span>
          </v-flex>
        </template>

        <template v-else v-for="(value,index) in topTabsCount.filters">
            <v-flex xs2>
              <label style="font-weight: 500;" class="blackLabel " >{{index}}:</label>
            </v-flex>
            <v-flex xs10 v-if="value.length > 0">
              <span>{{value[0]}}</span>
            </v-flex>
            <v-flex xs11 v-else>
              <span>{{topTabsCount.filters[index]}}</span>
            </v-flex>
        </template>

        <template v-if="Object.keys(tabs['is_initial_engagement_quote']).length > 0">
          <v-flex xs6 style="padding-top: 30px !important;">
            <label style="font-weight: 500; font-size: 16px" class="blackLabel  ">Initial Engagement and Quoting</label>
          </v-flex>
          <v-flex xs2 style="padding-top: 30px !important;">
            <label style="font-weight: 500; font-size: 16px; text-align: right !important" class="blackLabel floatRight" v-html="fncDisplayTopTabCount('is_initial_engagement_quote')"></label>
          </v-flex>
          <v-flex xs4 style="padding-top: 30px !important;">
            <label style="font-weight: 500; font-size: 16px; text-align: right !important" class="blackLabel floatRight" v-html="fncDisplayTopTabValue('is_initial_engagement_quote')"></label>
          </v-flex>
          <template v-for="(value,index) in tabs['is_initial_engagement_quote']" v-if="fncHideZero('is_initial_engagement_quote',value.description)">
            <v-flex xs6 class="pl-3">
              {{value.description}}
            </v-flex>
            <v-flex xs2>
                <span class="floatRight" v-html="fncDisplayBottomTabCount('is_initial_engagement_quote',value.description)"></span>
            </v-flex>
            <v-flex xs4>
              <span class="floatRight" v-html="fncDisplayBottomTabValue('is_initial_engagement_quote',value.description)"></span>
            </v-flex>
          </template>
        </template >

        <template v-if="Object.keys(tabs['is_negotiating_customer_approval']).length > 0">
          <v-flex xs6 style="padding-top: 30px !important;">
            <label style="font-weight: 500; font-size: 16px" class="blackLabel ">Negotiation Customer Approval</label>
          </v-flex>
          <v-flex xs2 style="padding-top: 30px !important;">
            <label style="font-weight: 500; font-size: 16px; text-align: right !important" class="blackLabel floatRight" v-html="fncDisplayTopTabCount('is_negotiating_customer_approval')"></label>
          </v-flex>
          <v-flex xs4 style="padding-top: 30px !important;">
            <label style="font-weight: 500; font-size: 16px; text-align: right !important" class="blackLabel floatRight" v-html="fncDisplayTopTabValue('is_negotiating_customer_approval')"></label>
          </v-flex>
          <template v-for="(value,index) in tabs['is_negotiating_customer_approval']" v-if="fncHideZero('is_negotiating_customer_approval',value.description)" >
            <v-flex xs6 class="pl-3">
              {{value.description}}
            </v-flex>
            <v-flex xs2 >
              <span class="floatRight" v-html="fncDisplayBottomTabCount('is_negotiating_customer_approval',value.description)"></span>
            </v-flex>
            <v-flex xs4 >
              <span class="floatRight" v-html="fncDisplayBottomTabValue('is_negotiating_customer_approval',value.description)"></span>
            </v-flex>
          </template>
        </template >

        <template v-if="Object.keys(tabs['is_manufacturer_fulfilment']).length > 0">
          <v-flex xs6 style="padding-top: 30px !important;">
            <label style="font-weight: 500; font-size: 16px" class="blackLabel ">Manufacture & Fulfilment</label>
          </v-flex>
          <v-flex xs2 style="padding-top: 30px !important;">
            <label style="font-weight: 500; font-size: 16px; text-align: right !important" class="blackLabel floatRight" v-html="fncDisplayTopTabCount('is_manufacturer_fulfilment')"></label>
          </v-flex>
          <v-flex xs4 style="padding-top: 30px !important;">
            <label style="font-weight: 500; font-size: 16px; text-align: right !important" class="blackLabel floatRight" v-html="fncDisplayTopTabValue('is_manufacturer_fulfilment')"></label>
          </v-flex>
          <template v-for="(value,index) in tabs['is_manufacturer_fulfilment']" v-if="fncHideZero('is_manufacturer_fulfilment',value.description)" >
            <v-flex xs6 class="pl-3">
              {{value.description}}
            </v-flex>
            <v-flex xs2 >
              <span class="floatRight" v-html="fncDisplayBottomTabCount('is_manufacturer_fulfilment',value.description)"></span>
            </v-flex>
            <v-flex xs4 >
              <span class="floatRight" v-html="fncDisplayBottomTabValue('is_manufacturer_fulfilment',value.description)"></span>
            </v-flex>
          </template>
        </template >

        <template v-if="Object.keys(tabs['is_cancelled_expired_rejected']).length > 0">
          <v-flex xs6 style="padding-top: 30px !important;">
            <label style="font-weight: 500; font-size: 16px" class="blackLabel ">Cancelled, Expired or Rejected</label>
          </v-flex>
          <v-flex xs2 style="padding-top: 30px !important;">
            <label style="font-weight: 500; font-size: 16px; text-align: right !important" class="blackLabel floatRight" v-html="fncDisplayTopTabCount('is_cancelled_expired_rejected')"></label>
          </v-flex>
          <v-flex xs4 style="padding-top: 30px !important;">
            <label style="font-weight: 500; font-size: 16px; text-align: right !important" class="blackLabel floatRight" v-html="fncDisplayTopTabValue('is_cancelled_expired_rejected')"></label>
          </v-flex>
          <template v-for="(value,index) in tabs['is_cancelled_expired_rejected']" v-if="fncHideZero('is_cancelled_expired_rejected',value.description)" >
            <v-flex xs6 class="pl-3">
              {{value.description}}
            </v-flex>
            <v-flex xs2 >
              <span class="floatRight" v-html="fncDisplayBottomTabCount('is_cancelled_expired_rejected',value.description)"></span>
            </v-flex>
            <v-flex xs4 >
              <span class="floatRight" v-html="fncDisplayBottomTabValue('is_cancelled_expired_rejected',value.description)"></span>
            </v-flex>
          </template>
        </template >

        <v-flex xs12 style="padding-top: 35px !important;border-radius: 5px;">
          <hr>
        </v-flex>
        <v-flex xs6 >
          <label style="font-weight: 500; font-size: 16px" class="blackLabel ">TOTAL QUOTES</label>
        </v-flex>
        <v-flex xs2 >
          <label style="font-weight: 500; font-size: 16px; text-align: right !important" class="blackLabel floatRight">{{topTabsCount.quote_total_count}}</label>
        </v-flex>
        <v-flex xs4 >
          <label style="font-weight: 500; font-size: 16px; text-align: right !important" class="blackLabel floatRight">R{{topTabsCount.quote_sum_total}}</label>
        </v-flex>

      </v-layout>
      </v-form>
      <div class="pl-4 pr-2 pb-4 buttonHolder">
        <div style="float: right">
          <v-btn class="text-xs-right cancelButton" @click.prevent="fncHideModal">Close</v-btn>
        </div>
      </div>

    </v-container>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "Modal_quote_totals",
  data () {
    return {
        showZero: true,
        reportSearch: null,
        quote_start_date: null,
        quote_end_date: null
    }
  },
  computed: {
    ...mapGetters([
      'objAuthorize',
      'globalModalParams',
      'regionSelectors',
      'userAddRoles',
      'totalPending',
      'topTabsCount',
      'tabs'
    ]),
    isReportSearch(){
      if (localStorage.getItem('reportSearch') !== null && localStorage.getItem('reportSearch') !== undefined && localStorage.getItem('reportSearch') !== ""){
          this.reportSearch = localStorage.getItem('reportSearch')
          this.quote_end_date = localStorage.getItem('quote_end_date')
          this.quote_start_date = localStorage.getItem('quote_start_date')
        return true
      }
      else{
        this.reportSearch = null
        return false
      }

    }
  },
  methods:{
    fncHideModal() {
      this.$store.commit('hideModal');
    },
    fncOpenFilters()
    {
      this.$root.$emit('open-filters')
      this.$store.commit('hideModal');

    },
    fncDisplayTopTabCount(topKey)
    {
      for (const [key, value] of Object.entries(this.topTabsCount)) {
        for (const [secondKey, data] of Object.entries(this.topTabsCount[key])) {
          if (secondKey === topKey){
            return this.topTabsCount[key][secondKey].total_count
          }
        }
      }
      return 0
    },
    fncDisplayTopTabValue(topKey)
    {
      if (this.topTabsCount !== undefined && Object.keys(this.topTabsCount).length !== 0){
        for (const [key, value] of Object.entries(this.topTabsCount)) {
          for (const [secondKey, data] of Object.entries(this.topTabsCount[key])) {
            if (secondKey === topKey){
              if (this.topTabsCount[key][secondKey].total === 0)
                return  'R0.0'
              else{

                return 'R'+ this.topTabsCount[key][secondKey].total
              }
            }
          }
        }
      }
      return  'R0.0'
    },
    fncDisplayBottomTabValue(topKey,bottomKey)
    {
      for (const [key, value] of Object.entries(this.topTabsCount)) {
        for (const [secondKey, data] of Object.entries(this.topTabsCount[key])) {
          if (data.hasOwnProperty(0)) {
            for (const [thirdKey, tab] of Object.entries(data[0])) {
              if (data[0][thirdKey].hasOwnProperty(bottomKey)) {
                return 'R'+ data[0][thirdKey][bottomKey].total
              }
            }
          }

        }
      }
    },
    fncDisplayBottomTabCount(topKey,bottomKey)
    {
      for (const [key, value] of Object.entries(this.topTabsCount)) {
        for (const [secondKey, data] of Object.entries(this.topTabsCount[key])) {
          if (data.hasOwnProperty(0)) {
            for (const [thirdKey, tab] of Object.entries(data[0])) {
              if (data[0][thirdKey].hasOwnProperty(bottomKey)) {
                return data[0][thirdKey][bottomKey].total_count
              }
            }
          }

        }
      }
    },
    fncHideZero(key, description)
    {
      if (!this.showZero && this.fncDisplayBottomTabCount(key,description) === 0){ //dont show zero
        return false
      }
      else {
        return true
      }
    },
    fncGenerateStatusSummaryReport(){
      this.$store.dispatch({
        type: 'fncGenerateStatusSummaryReport',
        topTabsCount: this.topTabsCount,
      })
    }
  },
}
</script>

<style scoped>
label.blackLabel {
  display: inline !important;
  vertical-align: middle;
}
.col-12 {
  padding-top: 0;
  padding-bottom: 0;
}
.theme--light.v-input {
  padding-top: 0;
}
.v-input__slot {
  margin-bottom: 0;
}
.inputs-container {

}
</style>
